var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconRating = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-rating",
    width: 18.811,
    height: 18.005,
    viewBox: "0 0 18.811 18.005",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.icon-rating .a{fill:#777;}\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.838.625l-2.3,4.655L2.4,6.03a1.126,1.126,0,0,0-.622,1.92L5.5,11.571,4.62,16.687a1.124,1.124,0,0,0,1.631,1.185l4.6-2.416,4.6,2.416a1.125,1.125,0,0,0,1.631-1.185l-.879-5.116,3.716-3.622a1.126,1.126,0,0,0-.622-1.92l-5.137-.749L11.856.625a1.126,1.126,0,0,0-2.018,0Z",
    transform: "translate(-1.441 0.001)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRating, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_rating.bb33c205.svg";
export { ForwardRef as ReactComponent };